module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "novels"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "nove_p1"
    }
  }, [_c('b', [_vm._v("Parker Novels By Richard Stark")])]), _vm._v(" "), _c('p', {
    staticClass: "extra-indent2",
    attrs: {
      "id": "nove_p2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "nove_p3"
    }
  }, [_c('i', [_vm._v("The Hunter (Payback)"), _c('br'), _c('br'), _vm._v("\nThe Man with the Getaway Face"), _c('br'), _c('br'), _vm._v("\nThe Outfit"), _c('br'), _c('br'), _vm._v("\nThe Mourner"), _c('br'), _c('br'), _vm._v("\nThe Score"), _c('br'), _c('br'), _vm._v("\nThe Jugger"), _c('br'), _c('br'), _vm._v("\nThe Seventh"), _c('br'), _c('br'), _vm._v("\nThe Handle"), _c('br'), _c('br'), _vm._v("\nThe Rare Coin Score"), _c('br'), _c('br'), _vm._v("\nThe Green Eagle Score"), _c('br'), _c('br'), _vm._v("\nThe Black Ice Score"), _c('br'), _c('br'), _vm._v("\nDeadly Edge"), _c('br'), _c('br'), _vm._v("\nSlayground"), _c('br'), _c('br'), _vm._v("\nLemons Never Lie"), _c('br'), _c('br'), _vm._v("\nPlunder Squad"), _c('br'), _c('br'), _vm._v("\nButcher's Moon"), _c('br'), _c('br'), _vm._v("\nComeback"), _c('br'), _c('br'), _vm._v("\nBackflash"), _c('br'), _c('br'), _vm._v("\nFlashfire"), _c('br'), _c('br'), _vm._v("\nFirebreak"), _c('br'), _c('br'), _vm._v("\nAsk the Parrot"), _c('br'), _c('br'), _vm._v("\nDirty Money")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-741d21a9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/novels.vue
// module id = 60
// module chunks = 0